import { withStyles } from '@mui/styles';

import ClientUserForm from './ClientUserForm';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(ClientUserForm);